/* ==========================================================================
   SPIRO+ MY — Sections batch C behaviors
   Scoped strictly to this batch's own data-attributes:
   [data-reviews], [data-customer-feedback], [data-wcs], [data-expert],
   [data-clinical-results]. No global selectors, no shared helper names.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- Generic scroll-snap carousel wiring (prev/next by one card width) ---- */
  function wireCarousel(track, prevBtn, nextBtn, cardSelector) {
    if (!track) return;

    function step() {
      var card = track.querySelector(cardSelector);
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '16') || 16;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
  }

  /* ---- Video card play/pause toggle (used by reviews + expert) ---- */
  function wireVideoCards(root, cardAttr, videoAttr, playAttr) {
    var cards = root.querySelectorAll('[' + cardAttr + ']');
    cards.forEach(function (card) {
      var video = card.querySelector('[' + videoAttr + ']');
      var playBtn = card.querySelector('[' + playAttr + ']');
      if (!video) return;

      card.addEventListener('click', function () {
        var isPlaying = !video.paused;

        // Pause any other playing videos within the same root
        root.querySelectorAll('[' + videoAttr + ']').forEach(function (v) {
          if (v !== video) v.pause();
        });
        root.querySelectorAll('[' + cardAttr + ']').forEach(function (c) {
          c.classList.remove('is-playing');
        });

        if (isPlaying) {
          video.pause();
        } else {
          video.muted = false;
          var playAttempt = video.play();
          if (playAttempt && typeof playAttempt.catch === 'function') {
            playAttempt.catch(function () { /* autoplay with sound blocked; ignore */ });
          }
          card.classList.add('is-playing');
        }
      });

      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          card.click();
        });
      }
    });
  }

  /* ---- Reviews section (video testimonials carousel) ---- */
  function initReviews(root) {
    var track = root.querySelector('[data-reviews-track]');
    var prevBtn = root.querySelector('[data-reviews-prev]');
    var nextBtn = root.querySelector('[data-reviews-next]');
    wireCarousel(track, prevBtn, nextBtn, '[data-reviews-video-card]');
    wireVideoCards(root, 'data-reviews-video-card', 'data-reviews-video', 'data-reviews-play');
  }

  /* ---- Customer feedback section (chat screenshot carousel) ---- */
  function initCustomerFeedback(root) {
    var track = root.querySelector('[data-feedback-track]');
    var prevBtn = root.querySelector('[data-feedback-prev]');
    var nextBtn = root.querySelector('[data-feedback-next]');
    wireCarousel(track, prevBtn, nextBtn, '.customer-feedback__card');
  }

  /* ---- What Customers Say section (full review carousel) ---- */
  function initWhatCustomersSay(root) {
    var track = root.querySelector('[data-wcs-track]');
    var prevBtn = root.querySelector('[data-wcs-prev]');
    var nextBtn = root.querySelector('[data-wcs-next]');
    wireCarousel(track, prevBtn, nextBtn, '.wcs__card');
  }

  /* ---- Expert section (video row) ---- */
  function initExpert(root) {
    wireVideoCards(root, 'data-expert-video-card', 'data-expert-video', 'data-expert-play');
  }

  /* ---- Clinical results (animate stat numbers into view) ---- */
  function initClinicalResults(root) {
    var stats = root.querySelectorAll('[data-clinical-stat-value]');
    if (!stats.length) return;

    if (!('IntersectionObserver' in window)) {
      stats.forEach(function (el) {
        var target = parseInt(el.getAttribute('data-target'), 10) || 0;
        var suffix = el.getAttribute('data-suffix') || '';
        el.textContent = target + suffix;
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.dataset.animated === 'true') return;
        el.dataset.animated = 'true';

        var target = parseInt(el.getAttribute('data-target'), 10) || 0;
        var suffix = el.getAttribute('data-suffix') || '';
        var duration = 1400;
        var startTime = null;

        function tick(now) {
          if (startTime === null) startTime = now;
          var progress = Math.min((now - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 4);
          el.textContent = Math.round(target * eased) + suffix;
          if (progress < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);

        observer.unobserve(el);
      });
    }, { threshold: 0.3 });

    stats.forEach(function (el) { observer.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-reviews]').forEach(initReviews);
    document.querySelectorAll('[data-customer-feedback]').forEach(initCustomerFeedback);
    document.querySelectorAll('[data-wcs]').forEach(initWhatCustomersSay);
    document.querySelectorAll('[data-expert]').forEach(initExpert);
    document.querySelectorAll('[data-clinical-results]').forEach(initClinicalResults);
  });
})();
